/* eslint-disable consistent-return */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useRef, useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./style.css";
import CarDetailStickyViewRevamp from "../car-detail-sticky-view-revamp";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import { GALLERY_TAB_TYPE } from "../car-detail-info/constant";
import Tab from "../../shared/tab";
import { NUMBER, PAGE_SOURCE } from "../../../constants/app-constants";
import VideoGallerySlider from "../video-gallery-slider";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";
import CarGalleryModal from "../car-gallery-modal/component";
import { VIDEO_CATALOG_AMPLITUDE_EVENTS, VIDEO_CATALOG_GA_EVENTS_DESKTOP } from "../video-gallery-slider/tracking";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import CarUspContainer from "../car-usp-container";
import CarNoImperfection from "../../shared/car-no-imperfection";
import TrackImpression from "../../shared/track-impression";
// import LazyImage from "../../shared/lazy-image";
import { VIDEO_TOUR_ICON } from "../../../constants/image-url-constant";
import getCarInfo from "../../../utils/helpers/get-car-info";
import { getCDPAltText } from "../../../utils/helpers/get-cdp-alt-text";

const SCROLL_DELAY_MS = 100;

const TABS_THREE_SIXTY_FLOW = [
    {
        text: "Car Tour",
        type: GALLERY_TAB_TYPE.carTour,
        key: GALLERY_TAB_TYPE.carTour,
        activeIndex: 0
    },
    {
        text: "Gallery",
        type: GALLERY_TAB_TYPE.allImages,
        key: GALLERY_TAB_TYPE.allImages,
        activeIndex: 0
    },
    {
        text: "360° Tour",
        type: GALLERY_TAB_TYPE.threeSixtyViewUrl,
        key: GALLERY_TAB_TYPE.threeSixtyViewUrl,
        activeIndex: 0
    }
];

const HelloARView = ({
    iframeUrl,
    galleryProps = {},
    onClickCallback = () => { },
    isWishlisted,
    onWishlistClick = () => { },
    comingSoon = false,
    ctaProps = {},
    content,
    onClickNotifyIcon,
    config,
    webCarTour,
    setGsGalleryDataConnect,
    hideImperfectionsDesktop,
    desktopPremiumFeatures
}) => {
    const hideImperfections = getAbExpirementVariant(hideImperfectionsDesktop, EXPERIMENT_TYPE.VARIANT_B);
    // const { exterior360Images, interior360Images, mediaSource } = content  || {};
    // const { exterior360, interior360 } = s20DummyData || {};
    const { isDealerListing } = getCarInfo(content);
    const { carTourData, carTourPresent, mainImage, threeSixtyViewAvailable, year, make, model, variant, transmissionType, odometerReading } = content || {};
    const altText = getCDPAltText({ year, make, model, variant, transmissionType, odometerReading });
    const exteriorImages = useMemo(() => content?.exteriorImages || [], [content.exteriorImages]);
    const interiorImages = useMemo(() => content?.interiorImages || [], [content.interiorImages]);
    const highlightsImages = useMemo(() => content?.highlightsGallery || [], [content.highlightsGallery]);
    const imperfectionImages = useMemo(() => content?.imperfectionImages || [], [content.imperfectionImages]);
    const galleryV2 = useMemo(() => content?.galleryV2 || [], [content.galleryV2]);

    // Only include highlights if the highlights tab should be visible
    const desktopPremiumFeaturesVariant = getAbExpirementVariant(desktopPremiumFeatures, EXPERIMENT_TYPE.VARIANT_B);
    const showHighlights = desktopPremiumFeaturesVariant || (hideImperfections && !threeSixtyViewAvailable);

    const allImages = useMemo(() => {
        if (isDealerListing) {
            return [...galleryV2];
        } else {
            return [...exteriorImages, ...interiorImages, ...(showHighlights ? highlightsImages : []), ...imperfectionImages];
        }
    }, [isDealerListing, galleryV2, exteriorImages, interiorImages, highlightsImages, imperfectionImages, showHighlights]);
    const { subActiveTab = "", imageName = "" } = galleryProps || {};
    const spinRef = useRef();
    const [isCarGalleryModalOpen, setIsCarGalleryModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const initialActiveTab = TABS_THREE_SIXTY_FLOW.find(tab => tab.key === galleryProps.activeTab) || TABS_THREE_SIXTY_FLOW[1];
    const [activeTab, setActiveTab] = useState(initialActiveTab);
    const [activeSubTab, setActiveSubTab] = useState(galleryProps.subActiveTab || GALLERY_TAB_TYPE.exterior);
    const { imageHost } = config || {};
    const exteriorRef = useRef(null);
    const interiorRef = useRef(null);
    const highlightsRef = useRef(null);
    const imperfectionRef = useRef(null);
    const imageRefs = useRef([]);
    const isWebCarTour = getAbExpirementVariant(webCarTour, EXPERIMENT_TYPE.VARIANT_B);
    const carImageUrl = (path) => fastlyUrl(imageHost, path, imageTypes.auCarDetailPreview);

    useEffect(() => {
        const spinRefContainer = (spinRef && spinRef.current) || window;
        const myConfObj = {
            iframeMouseOver: false
        };

        window.addEventListener("blur", () => {
            if (myConfObj.iframeMouseOver) {
                onClickCallback();
            }
        });
        spinRefContainer.addEventListener("mouseover", () => {
            myConfObj.iframeMouseOver = true;
            window.focus();
        });
        spinRefContainer.addEventListener("mouseout", () => {
            myConfObj.iframeMouseOver = false;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (galleryProps.subActiveTab === GALLERY_TAB_TYPE.exterior || galleryProps.subActiveTab === GALLERY_TAB_TYPE.imperfections || galleryProps.subActiveTab === GALLERY_TAB_TYPE.interior || galleryProps.subActiveTab === GALLERY_TAB_TYPE.highlights) {
            setActiveTab(TABS_THREE_SIXTY_FLOW.find(tab => tab.key === GALLERY_TAB_TYPE.allImages));
        } else if (galleryProps.subActiveTab !== GALLERY_TAB_TYPE.exterior && galleryProps.subActiveTab !== GALLERY_TAB_TYPE.imperfections && galleryProps.subActiveTab !== GALLERY_TAB_TYPE.interior && galleryProps.subActiveTab !== GALLERY_TAB_TYPE.highlights) {
            setActiveTab(TABS_THREE_SIXTY_FLOW.find(tab => tab.key === GALLERY_TAB_TYPE.threeSixtyViewUrl));
        } else {
            setActiveTab(TABS_THREE_SIXTY_FLOW.find(tab => tab.key === galleryProps.activeTab) || TABS_THREE_SIXTY_FLOW[1]);
        }
    }, [galleryProps.activeTab, galleryProps.subActiveTab]);

    useEffect(() => {
        if (activeTab.key === GALLERY_TAB_TYPE.allImages) {
            let scrollIndex = null;
            if (typeof galleryProps.selectedImageIndex === "number" && galleryProps.selectedImageIndex > -1) {
                scrollIndex = galleryProps.selectedImageIndex;
            } else if (galleryProps.subActiveTab === GALLERY_TAB_TYPE.exterior && exteriorImages.length > 0) {
                scrollIndex = allImages.indexOf(exteriorImages[0]);
            } else if (galleryProps.subActiveTab === GALLERY_TAB_TYPE.interior && interiorImages.length > 0) {
                scrollIndex = allImages.indexOf(interiorImages[0]);
            } else if (galleryProps.subActiveTab === GALLERY_TAB_TYPE.imperfections && imperfectionImages.length > 0) {
                scrollIndex = allImages.indexOf(imperfectionImages[0]);
            }
            if (scrollIndex !== null && imageRefs.current[scrollIndex]) {
                window.setTimeout(() => {
                    imageRefs.current[scrollIndex].scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "start"
                    });
                }, SCROLL_DELAY_MS);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, galleryProps.selectedImageIndex]);

    useEffect(() => {
        setActiveSubTab(galleryProps.subActiveTab || GALLERY_TAB_TYPE.exterior);
    }, [galleryProps.subActiveTab]);

    const handleImageClick = (imageData) => {
        setSelectedImage({
            ...imageData,
            imagePath: carImageUrl(imageData.path || mainImage?.path)
        });
        setIsCarGalleryModalOpen(true);
    };

    const isManualTabChange = useRef(false);
    const scrollTimeoutRef = useRef(null);

    // Update your handleSubTabClick function
    const handleSubTabClick = (tab) => {
        // Set flag to indicate manual tab change
        isManualTabChange.current = true;
        setActiveSubTab(tab);

        // Clear any existing timeout
        if (scrollTimeoutRef.current) {
            window.clearTimeout(scrollTimeoutRef.current);
        }

        window.setTimeout(() => {
            if (tab === GALLERY_TAB_TYPE.exterior && exteriorRef.current) {
                exteriorRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
            } else if (tab === GALLERY_TAB_TYPE.interior && interiorRef.current) {
                interiorRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
            } else if (tab === GALLERY_TAB_TYPE.imperfections && imperfectionRef.current) {
                imperfectionRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
            } else if (tab === GALLERY_TAB_TYPE.highlights && highlightsRef.current) {
                highlightsRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
            } else if (tab === GALLERY_TAB_TYPE.imperfections) {
                if (imperfectionImages.length > 0) {
                    imperfectionRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
                } else {
                    setActiveSubTab(GALLERY_TAB_TYPE.imperfections);
                }
            }

            // Re-enable observer after scroll animation completes (typically ~500-700ms for smooth scroll)
            scrollTimeoutRef.current = window.setTimeout(() => {
                isManualTabChange.current = false;
            }, NUMBER.ONE_THOUSAND_ONE);
        }, NUMBER.THREE_HUNDRED);

        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.GALLERY_PILL_SELECTED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.GALLERY_PILL_SELECTED,
            eventLabel: content.appointmentId,
            eventAction: tab
        });
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setGsGalleryDataConnect({
            selectedImageIndex: 0
        });
        setActiveSubTab(GALLERY_TAB_TYPE.exterior);
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.GALLERY_TAB_SELECTED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.GALLERY_TAB_SELECTED,
            eventLabel: tab.key,
            eventAction: "tab_selected"
        });

        if (tab.key === GALLERY_TAB_TYPE.carTour) {
            trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_CATALOGUE_ENTERED, {
                ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_CATALOGUE_ENTERED,
                eventLabel: "gallery",
                eventAction: content.appointmentId
            });
        }
    };

    iframeUrl = `${iframeUrl}${subActiveTab ? `&tab=threeSixtyViewUrl` : ""}${imageName ? `&image_name=${imageName}` : ""}&gid=${process.env.GA_ID}`;

    useEffect(() => {
        // Only set up observers when we're on the Gallery tab
        if (activeTab.key !== GALLERY_TAB_TYPE.allImages) return;

        // Don't set up observers if we're on imperfections tab with no images
        if (activeSubTab === GALLERY_TAB_TYPE.imperfections && imperfectionImages.length === 0) return;

        const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };

        // eslint-disable-next-line no-undef
        const observer = new IntersectionObserver((entries) => {
            // Skip if this is a manual tab change
            if (isManualTabChange.current) {
                return;
            }

            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (exteriorRef.current === entry.target) {
                        setActiveSubTab(GALLERY_TAB_TYPE.exterior);
                    } else if (interiorRef.current === entry.target) {
                        setActiveSubTab(GALLERY_TAB_TYPE.interior);
                    } else if (highlightsRef.current === entry.target) {
                        setActiveSubTab(GALLERY_TAB_TYPE.highlights);
                    } else if (imperfectionRef.current === entry.target) {
                        setActiveSubTab(GALLERY_TAB_TYPE.imperfections);
                    }
                }
            });
        }, observerOptions);

        // Observe the first image of each section
        if (exteriorRef.current) observer.observe(exteriorRef.current);
        if (interiorRef.current) observer.observe(interiorRef.current);
        if (highlightsRef.current) observer.observe(highlightsRef.current);
        if (imperfectionRef.current && imperfectionImages.length > 0) {
            observer.observe(imperfectionRef.current);
        }

        // Cleanup
        return () => {
            observer.disconnect();
            if (scrollTimeoutRef.current) {
                window.clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, [activeTab.key, activeSubTab, exteriorImages.length, interiorImages.length, imperfectionImages.length]);

    // Also add cleanup on component unmount
    useEffect(() => {
        return () => {
            if (scrollTimeoutRef.current) {
                window.clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, []);
    const handleImpressionView = (index) => {
        const imageData = allImages[index];
        if (imageData?.title) {
            trackDesktopCustomEventsAU(VIDEO_CATALOG_GA_EVENTS_DESKTOP.HIGHLIGHT_TAB_SEEN, {
                ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.HIGHLIGHT_TAB_SEEN,
                eventAction: allImages[index]?.title,
                eventLabel: content.appointmentId
            });
        }
    };
    return (
        <React.Fragment>
            <CarDetailStickyViewRevamp
                ctaProps={ctaProps}
                onWishlistClick={onWishlistClick}
                isWishlisted={isWishlisted}
                comingSoon={comingSoon}
                onClickNotifyIcon={onClickNotifyIcon}
                source="gallery"
                menuItems={[]}
                showCta={true}
            />
            <div styleName={"styles.twoTabsOuter"}>
                <div className="container">
                    <div styleName={"styles.sideGutters"}>
                        {TABS_THREE_SIXTY_FLOW
                            .filter(tab => {
                                // dont show ANY tab is isClassifieds is true
                                if (isDealerListing) {
                                    return false;
                                }
                                if (tab.key === GALLERY_TAB_TYPE.carTour) {
                                    return carTourPresent && isWebCarTour;
                                }
                                if (tab.key === "threeSixtyViewUrl") {
                                    return threeSixtyViewAvailable;
                                }
                                return true;
                            })
                            .map((tab) => (
                                <Tab
                                    key={tab.key}
                                    isActive={activeTab.key === tab.key}
                                    onClick={() => handleTabClick(tab)}
                                    activeStyle={"styles.activeTab"}
                                    tabStyle={"styles.videoGalleryTab"}
                                >
                                    {
                                        tab.key === GALLERY_TAB_TYPE.carTour ? (
                                            <img src={VIDEO_TOUR_ICON} styleName={"styles.mr-4"} alt="Car Tour" />
                                        ) : (
                                            tab.text
                                        )
                                    }
                                </Tab>
                            ))}
                    </div>
                </div>
            </div>
            {
                activeTab.key === TABS_THREE_SIXTY_FLOW[NUMBER.ONE].key && (
                    <React.Fragment>
                        {
                            !isDealerListing && (
                                <div styleName={"styles.smallTabsWrapper"}>
                                    <div styleName={`styles.smallTabs ${activeSubTab === GALLERY_TAB_TYPE.exterior ? "styles.smallTabsActive" : ""}`} onClick={() => handleSubTabClick(GALLERY_TAB_TYPE.exterior)}>
                                        <p styleName={"styles.smallTabsName"}>Exterior</p>
                                    </div>
                                    <div styleName={`styles.smallTabs ${activeSubTab === GALLERY_TAB_TYPE.interior ? "styles.smallTabsActive" : ""}`} onClick={() => handleSubTabClick(GALLERY_TAB_TYPE.interior)}>
                                        <p styleName={"styles.smallTabsName"}>Interior</p>
                                    </div>
                                    {showHighlights && highlightsImages.length > 0 && <div styleName={`styles.smallTabs ${activeSubTab === GALLERY_TAB_TYPE.highlights ? "styles.smallTabsActive" : ""}`} onClick={() => handleSubTabClick(GALLERY_TAB_TYPE.highlights)}>
                                        <p styleName={"styles.smallTabsName"}>Highlights</p>
                                    </div>}
                                    {!hideImperfections && <div styleName={`styles.smallTabs ${activeSubTab === GALLERY_TAB_TYPE.imperfections ? "styles.smallTabsActive" : ""}`} onClick={() => handleSubTabClick(GALLERY_TAB_TYPE.imperfections)}>
                                        <p styleName={"styles.smallTabsName"}><span>{imperfectionImages.length}</span>Imperfections</p>
                                    </div>}
                                </div>
                            )
                        }

                        {
                            // if activeSubTab is imperfections, and imperfectionImages.length is 0, then show a message
                            (activeSubTab === GALLERY_TAB_TYPE.imperfections && imperfectionImages.length === 0) ? (
                                <React.Fragment>
                                    <div className="container" style={{ display: "none" }}>
                                        <div styleName={"styles.imageGridContainer"}>
                                            {
                                                allImages.map((image, idx) => {
                                                    let ref = null;

                                                    if (exteriorImages.length > 0 && image === exteriorImages[0]) {
                                                        ref = exteriorRef;

                                                    }
                                                    if (interiorImages.length > 0 && image === interiorImages[0]) {
                                                        ref = interiorRef;

                                                    }
                                                    if (highlightsImages.length > 0 && image === highlightsImages[0]) {
                                                        ref = highlightsRef;

                                                    }
                                                    if (imperfectionImages.length > 0 && image === imperfectionImages[0]) {
                                                        ref = imperfectionRef;

                                                    }

                                                    // Use regular img tag for first image of each section or first 5 images

                                                    return (
                                                        <div styleName="styles.premiumItemsWrap" key={idx} onClick={() => handleImageClick(image, carImageUrl(image?.path || mainImage?.path))}>
                                                            <img
                                                                key={image?.path}
                                                                ref={el => { imageRefs.current[idx] = el; if (ref) ref.current = el; }}

                                                                src={carImageUrl(image?.path || mainImage?.path)}
                                                                alt={`${altText}, ${image?.label || ""}`.trim()}
                                                            />
                                                            {image.items && <CarUspContainer slideData={image} isInnerGallery={true} />}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                    <CarNoImperfection />
                                </React.Fragment>

                            ) : (
                                <div className="container">
                                    <div styleName={"styles.imageGridContainer"}>
                                        {
                                            allImages.map((image, idx) => {
                                                let ref = null;
                                                if (exteriorImages.length > 0 && image === exteriorImages[0]) {
                                                    ref = exteriorRef;

                                                }
                                                if (interiorImages.length > 0 && image === interiorImages[0]) {
                                                    ref = interiorRef;

                                                }
                                                if (highlightsImages.length > 0 && image === highlightsImages[0]) {
                                                    ref = highlightsRef;

                                                }
                                                if (imperfectionImages.length > 0 && image === imperfectionImages[0]) {
                                                    ref = imperfectionRef;

                                                }

                                                return (
                                                    <TrackImpression handleImpressionView={() => handleImpressionView(idx)}>
                                                        <div key={idx} onClick={() => handleImageClick(image, carImageUrl(image?.path || mainImage?.path))}>

                                                            <img
                                                                key={image?.path}
                                                                ref={el => { imageRefs.current[idx] = el; if (ref) ref.current = el; }}
                                                                src={carImageUrl(image?.path || mainImage?.path)}
                                                                alt={`${altText}, ${image?.label || ""}`.trim()}
                                                                styleName={idx <= NUMBER.FOUR ? "" : ""}
                                                            />

                                                            {image.items && <CarUspContainer slideData={image} isInnerGallery={true} />}

                                                        </div>
                                                    </TrackImpression>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </React.Fragment>
                )
            }
            {
                activeTab.key === TABS_THREE_SIXTY_FLOW[NUMBER.TWO].key && (
                    <div className="container" styleName="styles.rotateWrapper">
                        {/* {mediaSource === MEDIA_SOURCE.s20 ? <safecam-360-viewer
                            interior360={JSON.stringify(interior360Images)}
                            exterior360={JSON.stringify(exterior360Images)}
                            // galleryData={JSON.stringify(galleryData)}
                        /> : */}
                        <div styleName={"styles.iframeContainer"} className="row">
                            <iframe ref={spinRef} styleName="styles.spincarIframe" src={iframeUrl} height="100%" width="100%" />
                        </div>
                        {/* } */}
                    </div>
                )
            }
            {
                activeTab.key === TABS_THREE_SIXTY_FLOW[NUMBER.ZERO].key && carTourPresent && (
                    <div styleName="styles.carTourWrapper">
                        <VideoGallerySlider
                            videoUrl={carTourData?.videoPlayerUrl}
                            chapters={carTourData?.chapters}
                            footer={<></>}
                            source={PAGE_SOURCE.VIDEO_GALLERY}
                        />
                    </div>
                )
            }
            {
                isCarGalleryModalOpen && (
                    <CarGalleryModal
                        onClose={() => setIsCarGalleryModalOpen(false)}
                        imageData={selectedImage}
                        isDealerListing={isDealerListing}
                    />
                )
            }
        </React.Fragment>
    );
};

HelloARView.propTypes = {
    iframeUrl: PropTypes.string,
    text: PropTypes.string,
    galleryProps: PropTypes.object,
    onClose: PropTypes.func,
    content: PropTypes.object,
    onClickCallback: PropTypes.func,
    comingSoon: PropTypes.bool,
    ctaProps: PropTypes.object,
    isWishlisted: PropTypes.bool,
    onWishlistClick: PropTypes.func,
    onClickNotifyIcon: PropTypes.func,
    config: PropTypes.object,
    carTourPresent: PropTypes.bool,
    webCarTour: PropTypes.object,
    setGsGalleryDataConnect: PropTypes.func,
    hideImperfectionsDesktop: PropTypes.object,
    desktopPremiumFeatures: PropTypes.object
};

export default HelloARView;
